import React from 'react';
import { Typography, Box, keyframes } from '@mui/material';
import siriIcon from '../../assets/siri-icon.png';
import useVoiceAssistant from '../../hooks/useVoiceAssistant';
import useAISettings from '../../hooks/useAISettings'; // YENİ EKLENDİ

// Dinleme sırasındaki "nabız" animasyonu
const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(25, 118, 210, 0.7); }
  70% { box-shadow: 0 0 0 20px rgba(25, 118, 210, 0); }
  100% { box-shadow: 0 0 0 0 rgba(25, 118, 210, 0); }
`;

// Bekleme durumundaki "süzülme" animasyonu
const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-8px); }
  100% { transform: translateY(0px); }
`;

const VoiceAssistantUI = () => {
    const { enabled: isAssistantEnabled, loading: settingsLoading } = useAISettings(); // YENİ EKLENDİ
    const {
        isListening,
        isSpeaking,
        statusMessage,
        startListening,
        stopListening,
    } = useVoiceAssistant();

    const handleToggleListening = () => {
        if (isListening) {
            stopListening();
        } else {
            startListening();
        }
    };

    const isDisabled = isListening || isSpeaking;

    // YENİ EKLENDİ: Ayarlar yükleniyorsa veya asistan kapalıysa bileşeni render etme
    if (settingsLoading || !isAssistantEnabled) {
        return null;
    }

    return (
        <>
            {/* Status Overlay - Always Fixed */}
            <Box sx={{
                position: 'fixed',
                bottom: 100,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1400,
                opacity: (isListening || isSpeaking) ? 1 : 0,
                visibility: (isListening || isSpeaking) ? 'visible' : 'hidden',
                transition: 'opacity 0.3s, visibility 0.3s',
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                color: '#fff',
                padding: '8px 16px',
                borderRadius: '20px',
                boxShadow: 3,
                backdropFilter: 'blur(5px)',
                textAlign: 'center',
                minWidth: '200px',
                maxWidth: '90vw'
            }}>
                <Typography variant="caption">
                    {statusMessage}
                </Typography>
            </Box>

            {/* Trigger Button - Inline */}
            <Box onClick={handleToggleListening} sx={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', ml: 1 }}>
                <Box
                    sx={{
                        width: 40,
                        height: 40,
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        animation: isListening
                            ? `${pulse} 2s infinite`
                            : (isDisabled ? 'none' : `${float} 4s ease-in-out infinite`),
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)'
                        }
                    }}
                >
                    <Box
                        component="img"
                        src={siriIcon}
                        alt="Sesli Asistan"
                        sx={{
                            width: 32,
                            height: 32,
                            transition: 'transform 0.3s ease-in-out, filter 0.3s ease-in-out',
                            transform: isListening ? 'scale(1.15)' : 'scale(1.0)',
                            filter: isSpeaking ? 'brightness(0.7)' : 'none'
                        }}
                    />
                </Box>
            </Box>
        </>
    );
};

export default VoiceAssistantUI;